import { render, staticRenderFns } from "./AirWorkspace.vue?vue&type=template&id=9caebec0"
import script from "./AirWorkspace.vue?vue&type=script&lang=js"
export * from "./AirWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports